import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#F5F5F7] dark:bg-[#344d63] py-8 px-6 transition-colors duration-300">
      <div className="max-w-[980px] mx-auto">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <Link to="/" className="cursor-pointer">
            <div className="w-[150px] h-[150px] flex items-center justify-center">
              <img
                src="https://public.readdy.ai/ai/img_res/09855a0a-ea1e-45c4-a8bf-6d5918c6c158.png"
                alt="Sapentis AI Logo"
                className="w-full h-full object-contain"
              />
            </div>
          </Link>
        </div>

        {/* Navigation Links */}
        <div className="grid grid-cols-4 gap-8 pb-6 border-b border-[#D2D2D7] dark:border-[#4d6a82]">
          <div>
            <h4 className="text-xs font-semibold text-[#1D1D1F] dark:text-[#e8edf4] mb-3">Solutions</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">Operational Intelligence</a></li>
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">Revenue Optimization</a></li>
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">Systemized Growth</a></li>
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">Custom AI Systems</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-[#1D1D1F] dark:text-[#e8edf4] mb-3">Industries</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">Law Firms</a></li>
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">CPA & Accounting</a></li>
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">Healthcare</a></li>
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">Home Services</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-[#1D1D1F] dark:text-[#e8edf4] mb-3">Company</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">Case Studies</a></li>
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">Resources</a></li>
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-[#1D1D1F] dark:text-[#e8edf4] mb-3">Connect</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">LinkedIn</a></li>
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">Twitter</a></li>
              <li><a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">Email</a></li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-4 flex items-center justify-between">
          <p className="text-xs text-[#6E6E73] dark:text-[#8899aa]">© 2025 Sapentis AI. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-xs text-[#6E6E73] dark:text-[#8899aa] hover:text-[#1D1D1F] dark:hover:text-white transition-colors cursor-pointer">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
